import React, { PureComponent } from 'react'
import DropboxChooser from 'react-dropbox-chooser'

import config from 'config'
import { normalizeDropboxFiles } from 'helpers/pickerNormalizer'
import { getDropboxFileTypesAccepted } from 'helpers/pickerFileTypesAcceptedProvider'

class DropboxPickerPick extends PureComponent {

	constructor() {
		super()
		this.onChange = this.onChange.bind(this)
	}

	onChange(data) {
		this.props.onChange(normalizeDropboxFiles(data))
	}

	render() {

		return (
			<DropboxChooser
				appKey={config.dropbox.appKey}
				success={this.onChange}
				multiselect={this.props.multiselect}
				extensions={getDropboxFileTypesAccepted(this.props.accept)}
				linkType='direct'
			>
				{this.props.children}
			</DropboxChooser>
		)
	}
}

export default DropboxPickerPick
